
import React from "react";
import { Button } from "@/components/ui/button";

interface SortableHeaderProps {
  isSaving: boolean;
  onSaveOrder: () => void;
  onCancel: () => void;
}

export const SortableHeader: React.FC<SortableHeaderProps> = ({ 
  isSaving, 
  onSaveOrder, 
  onCancel 
}) => {
  return (
    <div className="flex justify-between items-center mb-4">
      <h2 className="text-xl font-bold text-[#00B6F0]">Organizar mentorias</h2>
      <div className="flex gap-2">
        <Button 
          variant="outline" 
          onClick={onCancel}
          disabled={isSaving}
        >
          Cancelar
        </Button>
        <Button 
          onClick={onSaveOrder} 
          disabled={isSaving}
          className="bg-[#00B6F0] hover:bg-[#00a0d6]"
        >
          {isSaving ? "Salvando..." : "Salvar ordem"}
        </Button>
      </div>
    </div>
  );
};
